import { render } from "./Help.vue?vue&type=template&id=937a1d16"
import script from "../js/help.js?vue&type=script&lang=js&external"
export * from "../js/help.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__